import {
  BankDetailsSection,
  type BankDetailsConfig,
} from "@project/user/components/bank-details-section";

import upiQrImg from "@project/assets/MahavirFoundation/mahavir-foundation-upi-qr.png";

const MAHAVIR_FOUNDATION_BANK_DETAILS: BankDetailsConfig = {
  orgName: "Bhagwan Mahavir Foundation Trust",
  bankName: "Kotak Mahindra Bank",
  branch: "Nr. Swaminarayan Tower, Maninagar, Ahmedabad",
  accountNumber: "1546406820",
  accountName: "Bhagwan Mahavir Foundation Trust",
  ifsc: "KKBK0002584",
  pan: "AAETB4218P",
  taxNote: "Trust registered under 80-G of Income Tax Act",
  upiId: "bmftrust@kotak",
  upiPayeeName: "BHAGWAN MAHAVIR FOUNDATION TRUST",
  qrImage: upiQrImg,
  qrDownloadName: "bhagwan-mahavir-foundation-trust-upi-qr.png",
};

/** Bank & UPI details for Healthcare donations */
export function MahavirFoundationBankDetails() {
  return (
    <BankDetailsSection
      id="mahavir-foundation-bank-details"
      details={MAHAVIR_FOUNDATION_BANK_DETAILS}
    />
  );
}
